var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],class:['error', _vm.isUserFromAPP && 'app-layout_error'],domProps:{"innerHTML":_vm._s(_vm.error)}})
}
var staticRenderFns = []

export { render, staticRenderFns }